/**
 * @author Fernando FH
 */
import PRM from "@/core/PermissionConstants";
import RouteConstants from "@/app/core/RouteConstants";

export default {
  name: RouteConstants.IMAGE_HISTORY.name,
  path: RouteConstants.IMAGE_HISTORY.path,
  component: () => import("@/app/views/ImageView.vue"),
  meta: {
    service: () => import("@/app/services/ImageHistoryService"),
    table: () => import("@/app/components/image/history/ImageHistoryTable.vue"),
    form: () => import("@/app/components/image/history/ImageInformationStudy.vue"),

    
    addenumViewer: () => import("@/app/components/interpretation/history/interpretationAddenumViewer.vue"),
    serviceDialog: () => import("@/app/services/TemplateDialogService"),
    tableDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogTable.vue"),
    formDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogForm.vue"),
    header: {
      icono: "mdi-camera-iris",
      texto: "Imagen > Historial",
      textNew: "Texto nuevo",
      textEdit: "Imagen > Historial > Información",
    },
    headerDialog: {
      icono: "mdi-wrench",
      texto: "Plantilla",
      textNew: "Nueva plantilla",
      textEdit: "Editar plantilla",
    },
    prm: PRM.MODULE_IMAGE_HISTORY,
    requireAuth: true,
    history: true,

    
    hideButtonAdd: true,
    addButtonText: "GUARDAR",
    cancelationModal: true,
    generatePDFModal: true,
    addenumViewerFlag: true,
    hideButtonAddDialog: false,
    addButtonTextDialog: "AGREGAR PLANTILLA",
  },
};